interface Props { status: string; statusFormatted: string; className?: string; }

const COLORS: Record<string, string> = {
    PENDING: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    CONFIRMED: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    NOT_CONFIRMED: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
};

const DraweeStatusBadge = ({ status, statusFormatted, className = '' }: Props) => {
    const color = COLORS[status] || COLORS.PENDING || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    return <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{statusFormatted || '—'}</span>;
};

export default DraweeStatusBadge;
